import React from "react";
import Head from "next/head";

interface SeoHead {
  pageName: string;
  pageDescription?: string;
}

export default function SeoHead({ pageName, pageDescription }: SeoHead) {
  return (
    <Head>
      <title>BerserkerMail - {pageName}</title>
      <meta property="og:title" content={`BerserkerMail - ${pageName}`} />
      <meta
        name="description"
        content={
          pageDescription
            ? pageDescription
            : "A web application created by marketers for marketers."
        }
      />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    </Head>
  );
}
